import { SearchField, SearchFieldSize } from '@xemplo/search-field';

import * as S from './list-search.styles';
import { ListSearchProps } from './list-search.types';

export function ListSearch({
  activeDescendantId,
  focusId,
  onSearchKeyDown,
  search,
  searchPlaceholder = 'Search...',
  setSearch,
  maxLength,
}: ListSearchProps) {
  return (
    <S.SearchWrapper>
      <SearchField
        id={focusId}
        name={`list-search-${focusId}`}
        value={search}
        aria-label="List search field"
        onChange={(e) => setSearch(e.target.value)}
        onClear={() => setSearch('')}
        onKeyDown={onSearchKeyDown}
        width="100%"
        placeholder={searchPlaceholder}
        tabIndex={activeDescendantId === focusId ? 0 : -1}
        inputSize={SearchFieldSize.Compact}
        maxLength={maxLength}
      />
    </S.SearchWrapper>
  );
}

export default ListSearch;
